import { render, staticRenderFns } from "./PipelinesPanel.vue?vue&type=template&id=967f2648&scoped=true"
import script from "./PipelinesPanel.vue?vue&type=script&lang=js"
export * from "./PipelinesPanel.vue?vue&type=script&lang=js"
import style0 from "./PipelinesPanel.vue?vue&type=style&index=0&id=967f2648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967f2648",
  null
  
)

export default component.exports